/**
 * Core enum types used across the promotion evaluation system
 */

export enum RoleType {
  CANDIDATE = 'CANDIDATE',
  ENDORSER = 'ENDORSER',
  MANAGER = 'MANAGER',
  ASSESSOR = 'ASSESSOR',
  SENIOR_LEADER = 'SENIOR_LEADER',
  HR = 'HR',
  BAR_RAISER = 'BAR_RAISER',
  OPPORTUNITY_AUTHOR = 'OPPORTUNITY_AUTHOR'
}

export enum PacketStatus {
  DRAFT = 'DRAFT',
  BLINDED_ASSESSMENT = 'BLINDED_ASSESSMENT',
  UNBLINDED_ASSESSMENT = 'UNBLINDED_ASSESSMENT',
  MANAGER_SUMMARY = 'MANAGER_SUMMARY',
  SENIOR_LEADER_REVIEW = 'SENIOR_LEADER_REVIEW',
  HR_REVIEW = 'HR_REVIEW',
  COMPLETED = 'COMPLETED',
  WITHDRAWN = 'WITHDRAWN'
}

export enum PacketVisibility {
  STANDARD = 'STANDARD',
  RESTRICTED = 'RESTRICTED'
}

export enum Decision {
  PROMOTE = 'PROMOTE',
  DEFER = 'DEFER'
}

export enum Ratification {
  RATIFIED = 'RATIFIED',
  OVERRULED = 'OVERRULED'
} 

export enum InvitationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED'
}

// Add AttestationDecision enum for global invitation attestation
export enum AttestationDecision {
  ATTESTED = 'ATTESTED',
  DENIED = 'DENIED'
} 
